<template>
  <d-container
    fluid
    class="main-content-container px-4">
    <!-- Page Header -->
    <d-row
      no-gutters
      class="page-header py-4">
      <d-col
        col
        sm="6"
        class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Grupy produktowe</span>
        <h3 class="page-title">
          <template v-if="isEdit">Edycja grupy</template>
          <template v-else>Dodawanie grupy</template>
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/grupy-produktowe')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
        <d-button
          theme="success"
          @click.prevent="validateForm">
          Zapisz zmiany
        </d-button>
      </d-col>
    </d-row>

    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-tabs card>
          <!-- Dane ogólne -->
          <d-tab
            title="Dane ogólne"
            active>
            <h4 class="mb-3 pb-3 bordering-bottom">
              Dane ogólne
            </h4>
            <validation-observer
              ref="groups-form"
              tag="form">
              <d-row>
                <d-col>
                  <div class="form-group">
                    <label for="name">
                      Nazwa grupy:
                    </label>
                    <validation-provider
                      rules="required"
                      name="name"
                      v-slot="{ errors }">
                      <d-input
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.name" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
                <d-col>
                  <div class="form-group">
                    <label for="ordering">
                      Kolejność:
                    </label>
                    <validation-provider
                      rules="required|min_value:0"
                      name="ordering"
                      v-slot="{ errors }">
                      <d-input
                        type="number"
                        id="ordering"
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.ordering" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>
            </validation-observer>
            <div
              v-if="!allDataLoaded"
              class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>
            <d-alert
              v-if="load_error"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a
                href="javascript:window.location.reload();"
              class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'product-groups-form',
  computed: {
    allDataLoaded () {
      return this.loaded;
    },
    isEdit () {
      return !!this.$route.params.id;
    },
  },
  data () {
    return {
      data: {
        id: 0,
        name: '',
        ordering: 0
      },
      loaded: false,
      load_error: false
    };
  },
  mounted () {
    if (this.isEdit) {
      this.loadItemData();
    } else {
      this.loaded = true;
    }
  },
  methods: {
    loadItemData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/product-groups/item/',
        instanceFields: ['name', 'ordering'],
        loadedKey: 'loaded'
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['groups-form'], this.submitForm);
    },
    submitForm () {
      let formDataToSend = this.prepareFormDataToSend();
      let endpointUrl = this.isEdit ? '/product-groups/update/' + this.$route.params.id : '/product-groups/store';

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano grupę',
        successText: 'Wybrana grupa została zapisana',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacja grupy nie powiodła się. Spróbuj ponownie.',
        successAction: () => {
          this.$router.push('/grupy-produktowe');
        }
      });
    },
    prepareFormDataToSend () {
      return {
        name: this.data.name,
        ordering: this.data.ordering,
      };
    }
  }
};
</script>
